import React from 'react';
import { Dialog, DialogProps } from '@mui/material';

interface DialogWrapperProps extends DialogProps {}

export const DialogWrapper: React.FC<DialogWrapperProps> = ({ children, PaperProps, BackdropProps, ...rest }) => {
  return (
    <Dialog
      {...rest}
      PaperProps={{
          sx: {
          bgcolor: (theme: any) => (theme.palette?.mode === 'light' ? '#FFFFFF' : theme.palette.background.paper),
          opacity: 1,
          borderRadius: 1,
          boxShadow: 24,
          border: (theme: any) => `1px solid ${theme.palette.divider}`,
          ...(PaperProps as any)?.sx,
        },
        ...(PaperProps as any),
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0,0,0,0.4)',
          ...((BackdropProps as any)?.sx || {}),
        },
        ...(BackdropProps as any),
      }}
    >
      {children}
    </Dialog>
  );
};

export default DialogWrapper;
